import React, { useEffect } from "react";
import Card from "src/componets/Card";
import { PostInterface } from "src/store/community/postsSlice";
import ListViewButtons from "src/componets/ListViewButtons";
import List from "src/pages/community/Images/_partials/_List";
import { queryParams } from "src/helpers/UrlHelpers";
import { useSearchParams } from "react-router-dom";
import { fetchImages } from "src/actions/community/imagesActions";
import { useAppDispatch } from "src/store/hooks";

const DEFAULT_VIEW = 'grid';

const _Details = ({ post }: { post: PostInterface | undefined }) => {
  const dispatch = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const listType: any   = queryParams.get(searchParams, 'view') || DEFAULT_VIEW;

  useEffect(() => {
    if (post) {
      dispatch(fetchImages({ params: { post_id: post.id } }));
    }
  }, [post, dispatch]);

  return (
    <>
      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Images</h4>

        <ListViewButtons align='right' defaultType={DEFAULT_VIEW} className='v-mb-10'/>

        <div>
          <List limit={100} targetId={post?.id} targetType='Post' type={listType}/>
        </div>
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Description</h4>
        {post?.description}
      </Card>

      <Card className='v-mb-20'>
        <h4 className='v-content-title'>Search text</h4>
        {post?.search_text}
      </Card>
    </>
  );
}

export default _Details;
